export default __webpack_public_path__ + "static/media/checkbox-unchecked-tata-neu.8f4b8bd9.png";